import { Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import FieldContainer from '../../../FormFields/FieldContainer';
import FormButtonOptions from '../../../FormFields/FormButtonOptions';
import FormDataDivider from '../../../FormFields/FormDataDivider';
import FormPhoneNumberField from '../../../FormFields/FormPhoneNumField';
import FormTextField from '../../../FormFields/FormTextField';
import FormNumberField from '../../../FormFields/FormNumberField';
import FormVendorField from '../../../FormFields/FormVendorField';
import FormTitle from '../../../FormFields/FormTitle';
import { FILE_TYPES } from '../../../formFileTypesEnum';
import { PAYROLL } from '../../../formQuestionsEnum';
import { OUTSOURCED_COMPANY_CATEGORIES } from '../../../optionEnums';
import { validateEmail } from '../../../ValidateFunctions';

DietarySection.propTypes = {
  permissions: PropTypes.object,
};

export default function DietarySection({ permissions }) {
  const {
    data: { outsourcedCompanyCategoriesList },
  } = useSelector((state) => state.transitions);
  const { watch } = useFormContext();
  const isOutsourced = watch(PAYROLL.DIETARY_IS_OUTSOURCED.fieldName);
  const [focusedField, setFocusedField] = useState(null);

  return (
    [
      PAYROLL.DIETARY_IS_OUTSOURCED.id,
      PAYROLL.DIETARY_OUTSOURCED_CATEGORY_ID.id,
      PAYROLL.OUTSOURCED_DIETARY_VENDOR.id,
      PAYROLL.DIETARY_OUTSOURCED_PHONE.id,
      PAYROLL.DIETARY_OUTSOURCED_EMAIL.id,
      PAYROLL.DIETARY_OUTSOURCED_HOURS_PER_WEEK.id,
    ].some((id) => id in permissions) && (
      <>
        <Grid item xs={12}>
          <Typography variant="subtitle1" color="text.secondary">
            Dietary
          </Typography>
        </Grid>
        {PAYROLL.DIETARY_IS_OUTSOURCED.id in permissions && (
          <Grid item xs={12}>
            <FormTitle fieldAttributes={{ questionTitle: 'Department type' }} />
            <FormButtonOptions
              fieldName={PAYROLL.DIETARY_IS_OUTSOURCED.fieldName}
              fieldAttributes={{
                isEditable: permissions[PAYROLL.DIETARY_IS_OUTSOURCED.id],
                options: [
                  { label: 'Outsourced', value: true },
                  { label: 'In House', value: false },
                ],
              }}
            />
          </Grid>
        )}

        {isOutsourced === true && (
          <>
            {PAYROLL.DIETARY_OUTSOURCED_CATEGORY_ID.id in permissions && (
              <Grid item xs={12}>
                <FormTitle fieldAttributes={{ questionTitle: 'Choose Category' }} />
                <FormButtonOptions
                  fieldName={PAYROLL.DIETARY_OUTSOURCED_CATEGORY_ID.fieldName}
                  fieldAttributes={{
                    isEditable: permissions[PAYROLL.DIETARY_OUTSOURCED_CATEGORY_ID.id],
                    options: outsourcedCompanyCategoriesList.filter(
                      (x) =>
                        x.value === OUTSOURCED_COMPANY_CATEGORIES.FULL_DEPARTMENT ||
                        x.value === OUTSOURCED_COMPANY_CATEGORIES.MANAGER_ONLY
                    ),
                  }}
                />
              </Grid>
            )}

            {PAYROLL.OUTSOURCED_DIETARY_VENDOR.id in permissions && (
              <Grid item xs={12}>
                <FormTitle
                  fieldAttributes={{
                    questionTitle: 'Dietary outsourced company',
                    fieldType: 'title',
                  }}
                />
                <FormVendorField
                  fieldName={PAYROLL.OUTSOURCED_DIETARY_VENDOR.fieldName}
                  fieldAttributes={{ isEditable: permissions[PAYROLL.OUTSOURCED_DIETARY_VENDOR.id] }}
                  invoiceFileTypeId={FILE_TYPES.DIETARY_OUTSOURCED_COMPANY_INVOICE}
                  contractFileTypeId={FILE_TYPES.DIETARY_OUTSOURCED_COMPANY_CONTRACT}
                />
              </Grid>
            )}

            {PAYROLL.DIETARY_OUTSOURCED_PHONE.id in permissions && (
              <Grid item xs={12} md={5}>
                <FieldContainer>
                  <FormTitle fieldAttributes={{ questionTitle: 'Phone' }} />
                  <FormPhoneNumberField
                    fieldName={PAYROLL.DIETARY_OUTSOURCED_PHONE.fieldName}
                    fieldAttributes={{ isEditable: permissions[PAYROLL.DIETARY_OUTSOURCED_PHONE.id] }}
                    focusedField={focusedField}
                    setFocusedField={setFocusedField}
                  />
                </FieldContainer>
              </Grid>
            )}

            {PAYROLL.DIETARY_OUTSOURCED_EMAIL.id in permissions && (
              <Grid item xs={12} md={5}>
                <FieldContainer>
                  <FormTitle fieldAttributes={{ questionTitle: 'Email' }} />
                  <FormTextField
                    fieldName={PAYROLL.DIETARY_OUTSOURCED_EMAIL.fieldName}
                    fieldAttributes={{
                      isEditable: permissions[PAYROLL.DIETARY_OUTSOURCED_EMAIL.id],
                      validation: {
                        pattern: { ...validateEmail },
                      },
                    }}
                    focusedField={focusedField}
                    setFocusedField={setFocusedField}
                  />
                </FieldContainer>
              </Grid>
            )}

            {PAYROLL.DIETARY_OUTSOURCED_HOURS_PER_WEEK.id in permissions && (
              <Grid item xs={12} md={2}>
                <FieldContainer>
                  <FormTitle fieldAttributes={{ questionTitle: 'Hours per week' }} />
                  <FormNumberField
                    fieldName={PAYROLL.DIETARY_OUTSOURCED_HOURS_PER_WEEK.fieldName}
                    fieldAttributes={{
                      isEditable: permissions[PAYROLL.DIETARY_OUTSOURCED_HOURS_PER_WEEK.id],
                    }}
                    focusedField={focusedField}
                    setFocusedField={setFocusedField}
                    allowDecimal
                  />
                </FieldContainer>
              </Grid>
            )}
          </>
        )}
        <FormDataDivider />
      </>
    )
  );
}
